/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateAlertRequest { 
    accountId?: string | null;
    miningProductId: number;
    positiveFrequency: number;
    negativeFrequency: number;
    percentThreshold: number;
    typeId: number;
    isEmailSendingEnabled: boolean;
    isTelegramSendingEnabled: boolean;
    isActive: boolean;
}

